import { Modal } from 'react-bootstrap';
import { useState } from 'react';
import { usePostApiRequest } from '../../helpers/api';
import { useQueryClient } from "@tanstack/react-query";

const RemoveAllCartModal = ({
    show,
    customerId,
    closeModalHandler,
}) => {

    const [, setIsLoading] = useState(false);
    const queryClient = useQueryClient();
    const postApiRequest = usePostApiRequest();
    const removeAllCardHandler = async () => {
        const payload = {
            CustomerId: customerId,
            Id: 0
        };
        try {
            const response = await postApiRequest({
                url: "/Customer/DeleteCart",
                method: "POST",
                data: payload,
            });
            if (response.Status === true) {
                queryClient.invalidateQueries({
                    queryKey: ["cartItemCount"],
                    exact: false,
                });
                queryClient.invalidateQueries({
                    queryKey: ["cartData"],
                    exact: false,
                });
            }
            setIsLoading(true);
        } catch (error) {
            console.error("API call failed:", error);
        } finally {
            setIsLoading(false);
        }
        closeModalHandler();
    }

    return (
        <div className="remove_cart_modal">
            <Modal
                show={show}
                onHide={closeModalHandler}
                backdrop="static"
                keyboard={false}
                dialogClassName="remove-cart-modal-dialog"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Remove All Cart
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are You Sure You Want To Clear All Cart ?
                </Modal.Body>
                <Modal.Footer className='remove-cart-modal-footer'>
                    <button className="close_btn" type="button" onClick={closeModalHandler}>
                        Cancel
                    </button>
                    <button className="submit_btn" type="button" onClick={removeAllCardHandler}>
                        Remove
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default RemoveAllCartModal;